import module from 'empresa/module.js'
import template from './template.html'
import {orderBy} from 'lodash'

export default class EmpresaCuentasComponent {
  empresaId = null
  exportando = false
  filtro = ''
  data = {}

  constructor ($q, $filter, $state, $stateParams, EmpresaCuentas, Permisos) {
    this.$q = $q
    this.$filter = $filter
    this.$state = $state
    this.$stateParams = $stateParams
    this.EmpresaCuentasService = EmpresaCuentas
    this.Permisos = Permisos
  }

  $onInit () {
    this.promise = this.$q.all([
      this.Permisos.modulos({exportar: 'finanzas.cuentasBancarias.exportar'})
        .then((response) => (this.permisos = response)),
      this.EmpresaCuentasService.get(this.empresaId)
        .then((response) => (this.data = orderBy(response.data.cuentas, ['banco', 'numero_cuenta']))),
    ])
  }
}

module.component('empresaCuentas', {
  controller: EmpresaCuentasComponent,
  template,
  bindings: {
    empresaId: '<',
  },
})



// WEBPACK FOOTER //
// ./src/empresa/components/cuentas/component.js